// import React, { useEffect, useState } from "react";
// import RiderServices from "../services/externalServices/riderServices";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   TablePagination,
//   Card,
//   CardContent,
//   CardHeader,
//   Paper,
//   Box,
//   CircularProgress,
// } from "@mui/material";

// function BidDetails({ riderId }) {
//   const [riderBids, setRiderBids] = useState({ bids: [] });
//   const [loading, setLoading] = useState(true); // Loader state
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   useEffect(() => {
//     getRidersBid();
//   }, []);

//   const getRidersBid = async () => {
//     try {
//       setLoading(true);
//       const res = await RiderServices.getRiderBids(riderId);
//       console.log("Response in BidDetails:", res);
//       setRiderBids(res);  // Assuming `res` contains the `bids` array
//     } catch (error) {
//       console.error("Error getting the Riders Bids:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const paginatedData = riderBids?.bids?.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   return (
//     <div style={{ padding: "20px" }}>
//       {loading ? (
//         // Loader while data is being fetched
//         <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
//           <CircularProgress />
//         </Box>
//       ) : riderBids?.bids?.length === 0 ? (
//         // Display message if no bids are available
//         <Typography variant="h6" textAlign="center">
//           No bids found for this rider.
//         </Typography>
//       ) : (
//         paginatedData.map((bid) => (
//           <Card key={bid._id} style={{ marginBottom: "20px" }}>
//             <CardHeader
//               title={
//                 <Box textAlign="center" sx={{ color: "grey", font: "bold" }}>
//                   Title: {bid?.packageTitles}
//                 </Box>
//               }
//               sx={{
//                 padding: "16px",
//                 backgroundColor: "#f5f5f5",
//               }}
//             />
//             <CardContent>
//               <TableContainer component={Paper}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Cab Requested Time</TableCell>
//                       <TableCell>Bid Time</TableCell>
//                       <TableCell>Service</TableCell>
//                       <TableCell>Rider Fee</TableCell>
//                       <TableCell>Base Amount</TableCell>
//                       <TableCell>Pickup Location</TableCell>
//                       <TableCell>Drop Location</TableCell>
//                       <TableCell>Status</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     <TableRow>
//                       <TableCell>
//                         {new Date(bid?.cabRequestDetails[0]?.created_at).toLocaleString()}
//                       </TableCell>
//                       <TableCell>
//                         {new Date(bid?.created_at).toLocaleString()}
//                       </TableCell>
//                       <TableCell>{bid?.serviceAssociated}</TableCell>
//                       <TableCell>₹{bid?.riderFee}</TableCell>
//                       <TableCell>₹{bid.pricing.baseAmount.value}</TableCell>
//                       <TableCell>
//                         {bid?.cabRequestDetails[0]?.pickup_location?.subText}
//                       </TableCell>
//                       <TableCell>
//                         {bid?.cabRequestDetails[0]?.drop_location?.subText}
//                       </TableCell>
//                       <TableCell>
//                         <Typography
//                           style={{
//                             color: bid.isAccepted ? "green" : "red",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           {bid.isAccepted ? "Accepted" : "Rejected"}
//                         </Typography>
//                       </TableCell>
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>
//         ))
//       )}
//       {!loading && riderBids?.bids?.length > 0 && (
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25, 50]}
//           component="div"
//           count={riderBids?.bids?.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       )}
//     </div>
//   );
// }

// export default BidDetails;


import React, { useEffect, useState } from "react";
import RiderServices from "../services/externalServices/riderServices";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Card,
  CardContent,
  CardHeader,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";

function BidDetails({ riderId }) {
  const [riderBids, setRiderBids] = useState({ bids: [] });
  const [loading, setLoading] = useState(true); // Loader state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // useEffect that re-fetches data when page or rowsPerPage changes
  useEffect(() => {
    getRidersBid();
  }, [page, rowsPerPage]); // Added page and rowsPerPage as dependencies

  const getRidersBid = async () => {
    try {
      setLoading(true);
      // Send pagination parameters as query params to the backend
      const res = await RiderServices.getRiderBids(riderId, { page, rowsPerPage });
      console.log("Response in BidDetails:", res);
      setRiderBids(res);  // Assuming `res` contains the `bids` array and `totalCount`
    } catch (error) {
      console.error("Error getting the Riders Bids:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        // Loader while data is being fetched
        <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
          <CircularProgress />
        </Box>
      ) : riderBids?.bids?.length === 0 ? (
        // Display message if no bids are available
        <Typography variant="h6" textAlign="center">
          No bids found for this rider.
        </Typography>
      ) : (
        riderBids?.bids?.map((bid) => (
          <Card key={bid._id} style={{ marginBottom: "20px" }}>
            <CardHeader
              title={
                <Box textAlign="center" sx={{ color: "grey", font: "bold" }}>
                  Title: {bid?.packageTitles}
                </Box>
              }
              sx={{
                padding: "16px",
                backgroundColor: "#f5f5f5",
              }}
            />
            <CardContent>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Cab Requested Time</TableCell>
                      <TableCell>Bid Time</TableCell>
                      <TableCell>Service</TableCell>
                      <TableCell>Rider Fee</TableCell>
                      <TableCell>Base Amount</TableCell>
                      <TableCell>Pickup Location</TableCell>
                      <TableCell>Drop Location</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {new Date(bid?.cabRequestDetails[0]?.created_at).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        {new Date(bid?.created_at).toLocaleString()}
                      </TableCell>
                      <TableCell>{bid?.serviceAssociated}</TableCell>
                      <TableCell>₹{bid?.riderFee}</TableCell>
                      <TableCell>₹{bid.pricing.baseAmount.value}</TableCell>
                      <TableCell>
                        {bid?.cabRequestDetails[0]?.pickup_location?.subText}
                      </TableCell>
                      <TableCell>
                        {bid?.cabRequestDetails[0]?.drop_location?.subText}
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{
                            color: bid.isAccepted ? "green" : "red",
                            fontWeight: "bold",
                          }}
                        >
                          {bid.isAccepted ? "Accepted" : "Rejected"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        ))
      )}
      {!loading && riderBids?.bids?.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={riderBids?.totalCount || 0}  // Assuming `totalCount` is returned for pagination
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </div>
  );
}

export default BidDetails;


